/**
 * スクロール量が 100lvh を超えたら固定ヘッダーを表示する
 */
export const fixedHeader = () => {
  const fixedHeader = document.querySelector(".js-header-fixed");
  if (!fixedHeader) return;

  const threshold = window.innerHeight;
  let isActive = false;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting && !isActive) {
        isActive = true;
        fixedHeader.classList.remove("_leaving");
        fixedHeader.classList.add("_active");
      } else if (entry.isIntersecting && isActive) {
        isActive = false;
        fixedHeader.classList.add("_leaving");
        fixedHeader.addEventListener(
          "animationend",
          () => {
            fixedHeader.classList.remove("_active", "_leaving");
          },
          { once: true }
        );
      }
    },
    { threshold: 0 }
  );

  const sentinel = document.createElement("div");
  sentinel.style.cssText = `position:absolute;top:${threshold}px;height:1px;width:1px;pointer-events:none;`;
  sentinel.setAttribute("aria-hidden", "true");
  document.body.appendChild(sentinel);

  observer.observe(sentinel);
};
